// src/pages/MarketingPage.jsx
import React, { useState, useEffect } from 'react';

const MarketingPage = () => {
    const [usuario, setUsuario] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem('usuario');
        if (storedUser) {
            setUsuario(JSON.parse(storedUser));
        }
    }, []);

    const getVideoEmbed = (username) => {
        switch (username) {
            case 'Marta':
                return 'https://www.youtube.com/embed/JIddQ2m4oXw?si=JT_pYbpUxQfvbpIB';
            case 'Estefania':
                return 'https://www.youtube.com/embed/PlrEc3E0WTY?si=CkPIMedQW6_zpW8A';
            case 'Samu':
                return 'https://www.youtube.com/embed/5TgaLGQc2y0?si=tt3rGdVRnZCVMn1r';
            case 'Fernando':
                return 'https://www.youtube.com/embed/HDCfV4s__Pg?si=2clEbMVDXf2gE-GH';
            case 'admin':
                return 'https://www.youtube.com/embed/eHwUOPG3DtQ?si=n6JdBODURCtMZ-Du';
            default:
                return null;
        }
    };

    const videoUrl = getVideoEmbed(usuario?.username);

    return (
        <div style={{ padding: '2rem' }}>
            <h1>Marketing</h1>
            <p>Bienvenido a la sección de marketing {usuario?.username || ''}.</p>
            {videoUrl && (
                <div style={{ marginTop: '2rem' }}>
                    <iframe
                        width="560"
                        height="315"
                        src={videoUrl}
                        title="Video de bienvenida"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            )}
        </div>
    );
};

export default MarketingPage;
